import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";
import { createColumnInlineInput, createColumnInlineInputNumber, createColumnInlineSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { createButtonCreate } from "../../../../../utils/button";
import { conditionFormChecker, onClickDeleteAllClient } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { createManageDelete, createPage } from "../../../../../utils/page";
import { callGetStorageLocationSubReserveAndUse } from "../../../haz-mgt/buy/storage-location/storage-location.logic";
import { callHazPackage } from "../../../haz/request/haz-package/package.logic";
import { setProductQty } from "../../../inspection/request/request.logic";

const Number = defineAsyncComponent(() => import("../../../../../components/table/custom-render/Number"));

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/informProductQty";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callQuantityUnit = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "QUANTITY_UNIT", value: searchQuery });

export const createColumns = ({ props, data }) => {
    const { viewOnly, itemsKey, storageLocations, request, inform, initInform, informProduct, informProducts, initInformProducts } = props;
    const { useForm } = data;
    const { modelRef, rulesRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const columns = [];
    if (props.viewOnlyInspection !== undefined) {
        columns.push(
            createColumnInlineInput({
                title: () => i18n.global.t("model.informProductQty.labels.docName"),
                dataIndex: "docName",
                items,
                useForm,
                itemsKey,
                customRenderInputProp: ({ record, key }) =>
                    lodash.merge(
                        {
                            disabled: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                    ),
                visible: () => true
            })
        );
    }
    columns.push(
        createColumnInlineSelect({
            visible: () => props.showStorageLocation,
            title: () => i18n.global.t("model.informProductQty.refStorageLocation"),
            dataIndex: "refStorageLocation",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: () => storageLocations, optLabel: "name" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: () => {
                            let storageLocationTemps = storageLocations;
                            if (inform.refOperation?.key === "1") {
                                storageLocationTemps = storageLocationTemps.filter(d =>
                                    moment(d.expireDate).isSameOrAfter(moment().format("YYYY-MM-DD"))
                                );
                            }
                            return storageLocationTemps;
                            // return storageLocationTemps.filter(
                            //     d =>
                            //         d.subs.filter(
                            //             d2 =>
                            //                 !informProduct.productQties
                            //                     .map(d3 => d3.refStorageLocationSub?.id)
                            //                     .filter(d3 => d3)
                            //                     .includes(d2.id)
                            //         ).length > 0
                            // );
                        },
                        optLabel: "name",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.refStorageLocation = value;
                            record.refStorageLocationSub = null;
                            record.refStorageLocationSubItem = null;
                            record.lot = null;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: 200
        })
    );
    columns.push(
        createColumnInlineSelect({
            visible: () => props.showStorageLocation,
            title: () => i18n.global.t("model.informProductQty.refStorageLocationSub"),
            dataIndex: "refStorageLocationSub",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: ({ field }) => lodash.get(modelRef, field.name).refStorageLocation.subs, optLabel: "buildingName" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly || !record.refStorageLocation,
                        list: () => {
                            if (!props.showLot) {
                                return record.refStorageLocation.subs.filter(
                                    d =>
                                        !informProduct.productQties
                                            .map(d2 => d2.refStorageLocationSub?.id)
                                            .filter(d2 => d2)
                                            .includes(d.id)
                                );
                            }
                            return record.refStorageLocation.subs;
                            // return record.refStorageLocation.subs.filter(
                            //     d =>
                            //         d.items.filter(
                            //             d2 =>
                            //                 !informProduct.productQties
                            //                     .map(d3 => d3.refStorageLocationSubItem?.id)
                            //                     .filter(d3 => d3)
                            //                     .includes(d2.id)
                            //         ).length > 0
                            // );
                        },
                        optLabel: "buildingName",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.refStorageLocationSub = value;
                            record.refStorageLocationSubItem = null;
                            record.lot = null;
                            if (inform.refOperation?.key === "1" && value) {
                                setIsLoadingApp(true);
                                callGetStorageLocationSubReserveAndUse({ stroageLocationSubId: value.id })
                                    .then(d => {
                                        record.refStorageLocationSub.useKgReserve = d.reserve;
                                        record.refStorageLocationSub.useKgUse = d.use;
                                    })
                                    .finally(() => setIsLoadingApp(false));
                            }
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            visible: () => props.showLot,
            title: () => i18n.global.t("model.informProductQty.refStorageLocationSubItem"),
            dataIndex: "refStorageLocationSubItem",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: ({ field }) => lodash.get(modelRef, field.name).refStorageLocationSub.items, optLabel: "lot" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly || !record.refStorageLocationSub,
                        list: () => {
                            return record.refStorageLocationSub.items;
                            // return record.refStorageLocationSub.items.filter(
                            //     d =>
                            //         !informProduct.productQties
                            //             .map(d2 => d2.refStorageLocationSubItem?.id)
                            //             .filter(d2 => d2)
                            //             .includes(d.id)
                            // );
                        },
                        optLabel: "lot",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.refStorageLocationSubItem = value;
                            record.lot = value?.lot;
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: 200
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.informProductQty.qty"),
            dataIndex: "qty",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.qty = value;
                            record.setProductQty?.({ modelRef, record, informProduct });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: 100
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.informProductQty.refQtyUnit"),
            dataIndex: "refQtyUnit",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callQuantityUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callQuantityUnit,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            /*
                            record.isSave = true;
                            record.refQtyUnit = value;
                            */
                            items.forEach(item => {
                                item.isSave = true;
                                item.refQtyUnit = value;
                            });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () =>
                !props.showStorageLocation
                    ? i18n.global.t("model.informProductQty.netWeight")
                    : i18n.global.t("views.request.informProductQty.netWeight"),
            dataIndex: "netWeight",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        addonAfter: () => {
                            if (!props.showStorageLocation) {
                                return null;
                            }
                            let balance = calNetWeightRemaining({
                                request,
                                inform,
                                initInform,
                                informProduct: informProduct,
                                informProductQties:
                                    inform.refOperation?.key === "1"
                                        ? informProducts.flatMap(d => d.productQties)
                                        : informProducts
                                              .filter(d => d.refHazObject?.id === informProduct.refHazObject?.id)
                                              .flatMap(d => d.productQties),
                                initInformProductQties:
                                    inform.refOperation?.key === "1"
                                        ? initInformProducts?.flatMap(d => d.productQties)
                                        : initInformProducts
                                              ?.filter(d => d.refHazObject?.id === informProduct.refHazObject?.id)
                                              ?.flatMap(d => d.productQties),
                                storageLocationSub: record.refStorageLocationSub,
                                storageLocationSubItem: record.refStorageLocationSubItem,
                                balanceOnly: props?.balanceOnly
                            });
                            //if (balance < 0) balance = 0;
                            return (
                                <div>
                                    /<Number text={balance} allowPrecision={true}></Number>
                                </div>
                            );
                        },
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.netWeight = value;
                            Object.keys(rulesRef)
                                .filter(d => d.endsWith?.("quantityRemaining") || new RegExp(`productQties\\.[^\\.]+\\.netWeight$`, "g").test(d))
                                .forEach(d => useForm.validate(d));
                            record.setProductQty?.({ modelRef, record, informProduct });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: !props.showStorageLocation ? 150 : 250
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.informProductQty.refNetWeightUnit"),
            dataIndex: "refNetWeightUnit",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callQuantityUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callQuantityUnit,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            /*
                            record.isSave = true;
                            record.refNetWeightUnit = value;
                            */
                            items.forEach(item => {
                                item.isSave = true;
                                item.refNetWeightUnit = value;
                            });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.informProductQty.refPackagingCharacteristic"),
            dataIndex: "refPackagingCharacteristic",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callHazPackage, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callHazPackage,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.refPackagingCharacteristic = value;
                            /*
                            record.isSave = true;
                            record.refPackagingCharacteristic = value;
                            */
                            items.forEach(item => {
                                item.isSave = true;
                            //     item.refPackagingCharacteristic = value;
                            });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.informProductQty.numberOfPackage"),
            dataIndex: "numberOfPackage",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.numberOfPackage = value;
                            record.setProductQty?.({ modelRef, record, informProduct });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: 100
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.informProductQty.packageSize"),
            dataIndex: "packageSize",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.packageSize = value;
                            record.setProductQty?.({ modelRef, record, informProduct });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                ),
            width: 100
        })
    );
    columns.push(
        createColumnInlineSelect({
            title: () => i18n.global.t("model.informProductQty.refPackageUnit"),
            dataIndex: "refPackageUnit",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ list: callQuantityUnit, optLabel: "value" }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        list: callQuantityUnit,
                        optLabel: "value",
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.refPackageUnit = value;
                            /*
                            record.isSave = true;
                            record.refPackageUnit = value;
                            */
                            items.forEach(item => {
                                item.isSave = true;
                                // item.refPackageUnit = value;
                            });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    columns.push(
        createColumnInlineInputNumber({
            title: () => i18n.global.t("model.informProductQty.amount"),
            dataIndex: "amount",
            items,
            useForm,
            itemsKey,
            inputProp: () => ({ allowPrecision: true }),
            customRenderInputProp: ({ record, key }) =>
                lodash.merge(
                    {
                        disabled: viewOnly,
                        allowPrecision: true,
                        "onUpdate:value": value => {
                            informProduct.isSave = true;
                            record.isSave = true;
                            record.amount = value;
                            record.setProductQty?.({ modelRef, record, informProduct });
                        }
                    },
                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field: { key }, model: record, informProduct } })
                )
        })
    );
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, canCreate, canDelete, informProduct, isCombineQty /* , hazLicense */ } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const initItems = itemsKey ? lodash.get(initialModel, itemsKey) : initialModel;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [
        createManageDelete({
            menuContext,
            visible: () => (viewOnly ? false : canDelete),
            onClick: ({ rowSelection }) => {
                informProduct.isSave = true;
                onClickDeleteAllClient({ rowSelection, useForm, items, key: itemsKey });
                data.page.page = 0;
            }
        })
    ];
    data.manageExtras = [
        {
            render: () =>
                createButtonCreate({
                    onClick: () => {
                        callQuantityUnit({}).then(quantityUnits => {
                            const newData = {
                                refQtyUnit: lodash.cloneDeep(items[0]?.refQtyUnit) || quantityUnits.find(d => d.key === "KGM"),
                                refNetWeightUnit: lodash.cloneDeep(items[0]?.refNetWeightUnit) || quantityUnits.find(d => d.key === "KGM"),
                                refPackageUnit: lodash.cloneDeep(items[0]?.refPackageUnit) || quantityUnits.find(d => d.key === "KGM"),
                                refPackagingCharacteristic: lodash.cloneDeep(items[0]?.refPackagingCharacteristic) || null
                            };
                            /*
                            if (hazLicense) {
                                newData.refQtyUnit = lodash.cloneDeep(hazLicense.refQuantityUnit);
                                newData.refNetWeightUnit = lodash.cloneDeep(hazLicense.refQuantityUnit);
                                newData.refPackageUnit = lodash.cloneDeep(hazLicense.refQuantityUnit);
                                newData.refPackagingCharacteristic = lodash.cloneDeep(items[0]?.refPackagingCharacteristic);
                            }
                            */
                            items.push(newData);
                        });
                    }
                }),
            visible: () => (viewOnly ? false : canCreate)
        }
    ];
    data.rowActions = [];
    fetchData({ props, data }).then(page => {
        if (isCombineQty) {
            combineProductQty({ data, page });
        }
        items?.push(...lodash.cloneDeep(page.data));
        initItems?.push(...lodash.cloneDeep(page.data));
    });
};

const combineProductQty = ({ data, page }) => {
    const { useForm } = data;
    const { modelRef } = useForm;

    const releaseProducts = modelRef.refReleaseTemp?.products || [];
    const releaseProductQties = [];
    page.data.forEach(informProductQty => {
        informProductQty.docName = i18n.global.t("model.informProductQty.labels.referDoc");
        informProductQty?.refInformProduct?.refTransferDeclarationProduct?.productQties?.forEach(d => {
            d.docName = i18n.global.t("model.informProductQty.labels.transferDeclarationDoc");
            page.data.push(d);
        });
        if (informProductQty.inspectionProductQties?.length > 0) {
            page.data.push(...informProductQty.inspectionProductQties);
            informProductQty.inspectionProductQties.forEach(inspectionProductQty => {
                inspectionProductQty.docName = i18n.global.t("model.informProductQty.labels.inspectionDoc");
                if (inspectionProductQty.releaseProductQties?.length > 0) {
                    inspectionProductQty.releaseProductQties.forEach(releaseProductQty => {
                        releaseProductQty.docName = i18n.global.t("model.informProductQty.labels.releaseDoc");
                        releaseProductQty.enable = true;
                        releaseProductQty.setProductQty = ({ modelRef, record, informProduct }) =>
                            setProductQty({
                                modelRef,
                                record,
                                informProduct,
                                productsKey: "refReleaseTemp.products",
                                productKey: "refInspectionProduct.refInformProduct"
                            });
                    });
                    releaseProductQties.push(...inspectionProductQty.releaseProductQties);
                } else {
                    const releaseProduct = releaseProducts?.find(
                        d => d.refInspectionProduct?.refInformProduct?.id === informProductQty.refInformProduct.id
                    );
                    releaseProduct?.productQties?.forEach(qty => {
                        qty.docName = i18n.global.t("model.informProductQty.labels.releaseDoc");
                        const exist = releaseProductQties.find(d => (d.id && d.id === qty.id) || (d._id && d._id === qty._id));
                        if (!exist) {
                            releaseProductQties.push(qty);
                        }
                    });
                }
            });
        }
    });
    page.data.push(...releaseProductQties);
};

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria })
        .then(page => {
            if (props.inform?.refOperation?.key === "1") {
                return callGetStorageLocationSubReserveAndUse({
                    stroageLocationSubId: lodash.uniq(page.data.map(informProductQty => informProductQty.refStorageLocationSub?.id).filter(d => d))
                })
                    .then(reserveUses => {
                        page.data.forEach(informProductQty => {
                            if (informProductQty.refStorageLocationSub) {
                                const reserveUse = reserveUses.find(
                                    reserveUse => reserveUse.refStorageLocationSubId === informProductQty.refStorageLocationSub.id
                                );
                                informProductQty.refStorageLocationSub.useKgReserve = reserveUse.reserve;
                                informProductQty.refStorageLocationSub.useKgUse = reserveUse.use;
                            }
                        });
                    })
                    .then(() => page);
            }
            return page;
        })
        .finally(() => setIsLoading(false));
};

export const calNetWeightRemaining = ({
    inform,
    initInform,
    informProductQties,
    initInformProductQties,
    storageLocationSub,
    storageLocationSubItem,
    balanceOnly
}) => {
    let result = 0;
    if (inform?.refOperation?.key === "1" && storageLocationSub) {
        let add = inform.id
            ? initInformProductQties
                  ?.filter(d => d.netWeight?.toString())
                  ?.filter(d => d.refStorageLocationSub?.id === storageLocationSub.id)
                  ?.map(d => d.netWeight)
                  ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0) || 0.0
            : 0.0;
        let add2 = !inform.id
            ? informProductQties
                  ?.filter(d => d.refReal?.netWeight?.toString())
                  ?.filter(d => d.refReal.refStorageLocationSub?.id === storageLocationSub.id)
                  ?.map(d => d.refReal.netWeight)
                  ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0) || 0.0
            : 0.0;
        let subtract = informProductQties
            ?.filter(d => d.isDelete !== true)
            ?.filter(d => d.netWeight?.toString())
            ?.filter(d => d.refStorageLocationSub?.id === storageLocationSub.id)
            ?.map(d => d.netWeight)
            ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0);
        let balance =
            parseFloat(storageLocationSub.useKg || 0) -
            parseFloat(storageLocationSub.useKgReserve || 0) -
            parseFloat(storageLocationSub.useKgUse || 0);
        if (balanceOnly) {
            result = balance;
        } else {
            result = balance + (inform.refOperation?.key === initInform?.refOperation?.key ? add + add2 : 0.0) - subtract;
        }
    } else if (inform?.refOperation?.key === "2" && storageLocationSubItem) {
        let add = inform.id
            ? initInformProductQties
                  ?.filter(d => d.netWeight?.toString())
                  ?.filter(d => d.refStorageLocationSubItem?.id === storageLocationSubItem.id)
                  ?.map(d => d.netWeight)
                  ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0) || 0.0
            : 0.0;
        let add2 = !inform.id
            ? informProductQties
                  ?.filter(d => d.refReal?.netWeight?.toString())
                  ?.filter(d => d.refReal.refStorageLocationSubItem?.id === storageLocationSubItem.id)
                  ?.map(d => d.refReal.netWeight)
                  ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0) || 0.0
            : 0.0;
        let subtract = informProductQties
            ?.filter(d => d.isDelete !== true)
            ?.filter(d => d.netWeight?.toString())
            ?.filter(d => d.refStorageLocationSubItem?.id === storageLocationSubItem.id)
            ?.map(d => d.netWeight)
            ?.reduce((accumulator, current) => parseFloat(accumulator || 0) + parseFloat(current || 0), 0);
        let balance = parseFloat(storageLocationSubItem.amount || 0) - parseFloat(storageLocationSubItem.reserveOut || 0);
        if (balanceOnly) {
            result = balance;
        } else {
            result = balance + (inform.refOperation?.key === initInform?.refOperation?.key ? add + add2 : 0.0) - subtract;
        }
    }
    return result;
};
